import type {
	FacilityPayload,
	FacilityStatus,
} from '@Application/Facilities/Facilities/Actions/facilitiesFetched';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class FacilityView {
	readonly id: number;
	readonly name: string;
	readonly address: string | null;
	readonly phoneNumber: string | null;
	readonly status: FacilityStatus;
	readonly assignedUserCount: number;

	constructor(payload: FacilityPayload) {
		this.id = payload.id;
		this.name = payload.name;
		this.address = payload.address;
		this.phoneNumber = payload.phoneNumber;
		this.status = payload.status;
		this.assignedUserCount = payload.assignedUserCount;

		Object.freeze(this);
	}

	get hasNoAssignedUser(): boolean {
		return this.assignedUserCount === 0;
	}
}

export default FacilityView;
